import { create } from 'zustand';
import { SelectedData, WorkDetailSimpleData, WorkSimpleForImportData, WorkSimpleWithDetails } from '../dto/EntityRepository';
import { IMPORT_STATION_SELECTED_MAX_COUNT } from '../constants/limits';

interface ImportStationWorkState {
  selectedDataList: SelectedData[];
  setSelectedDataList: (list: SelectedData[]) => void;
  addSelectedData: (data: SelectedData) => void;
  removeSelectedData: (data: SelectedData) => void;
  clearSelectedDataList: () => void;
  simpleList: WorkSimpleWithDetails[];
  setSimpleList: (list: WorkSimpleForImportData[]) => void;
  setDetailListForWork: (workId: string, detailList: WorkDetailSimpleData[]) => void;
  clearSimpleList: () => void;
}

const isSameSelection = (a: SelectedData, b: SelectedData) =>
  a.workId === b.workId && a.detailId === b.detailId;

export const useImportStationWorkStore = create<ImportStationWorkState>((set) => ({
  selectedDataList: [],
  setSelectedDataList: (list) => set({ selectedDataList: list }),
  addSelectedData: (data) =>
    set((state) => {
      if (state.selectedDataList.some((s) => isSameSelection(s, data))) return state;
      if (state.selectedDataList.length >= IMPORT_STATION_SELECTED_MAX_COUNT) return state;
      return { selectedDataList: [...state.selectedDataList, data] };
    }),
  removeSelectedData: (data) =>
    set((state) => ({
      selectedDataList: state.selectedDataList.filter((s) => !isSameSelection(s, data)),
    })),
  clearSelectedDataList: () => set({ selectedDataList: [] }),
  simpleList: [],
  setSimpleList: (list) =>
    set({
      simpleList: list.map((work) => ({ ...work, detailList: [] as WorkDetailSimpleData[] })),
    }),
  setDetailListForWork: (workId, detailList) =>
    set((state) => ({
      simpleList: state.simpleList.map((work) =>
        work.id === workId ? { ...work, detailList } : work
      ),
    })),
  clearSimpleList: () =>
    set({
      selectedDataList: [],
      simpleList: [],
    }),
}));
